module.exports = __webpack_public_path__ + "static/img/success5.1f1aff4c.png";